import { useLang } from "@/i18n/LanguageContext";
import { LINKS } from "@/i18n/translations";

export const StoreBadges = ({ idPrefix = "badges" }) => {
  const { lang, t } = useLang();
  return (
    <div className="flex items-center gap-3">
      <a
        href={LINKS.appStore}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${idPrefix}-appstore-badge`}
        className="transition-transform duration-200 hover:scale-[1.04]"
      >
        <img
          src={lang === "es" ? "/badges/appstore-es.svg" : "/badges/appstore-en.svg"}
          alt={t.footer.appStoreAlt}
          width="135"
          height="45"
          className="h-[45px] w-auto"
        />
      </a>
      <a
        href={LINKS.googlePlay}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${idPrefix}-googleplay-badge`}
        className="transition-transform duration-200 hover:scale-[1.04]"
      >
        <img
          src={lang === "es" ? "/badges/googleplay-es.png" : "/badges/googleplay-en.png"}
          alt={t.footer.playAlt}
          width="168"
          height="65"
          className="h-[65px] w-auto -my-2"
        />
      </a>
    </div>
  );
};
